import {
    State,
} from './state';

import {
    Insurance
} from './insurance-data'

export const SET = 'one-state-insurance/set';
export const RESET = 'one-state-insurance/reset';
export const SELECT = 'one-state-insurance/select';

export type InsuranceState = State<Insurance>;